import {
	APP_REGISTER_COMPLETED,
	APP_REGISTER_FAILED,
	APP_REGISTER_INIT,
	APP_REGISTER_LOADING,
	APP_SAVE_DEVICE_INFO,
	APP_SAVE_USER_INFO,
	APP_SAVE_USER_INFO_FAIL,
	APP_SAVE_USER_TOKEN_FAILED,
	AUTH_ERROR,
	LOGIN_FAIL,
	LOGIN_SUCCESS,
	LOGOUT_SUCCESS,
	LOGOUT_USER,
	USER_LOADED,
	USER_LOADING,
	USER_UPDATE,
	SAVE_USER_PROFILE,
} from "../actions/types";
const initialState = {
	token: localStorage.getItem("token"),
	isAuthenticated: false,
	isLoading: false,
	isFailed: false,
	user: { profile: {} },
	errorappMessage: null,
	app_is_registering: false,
	app_registation_completed: false,
	app__token_saved: false,
	app_user: null,
	app_deviceInfo: null,
	App_RegistrationStep: 0,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case USER_UPDATE:
			let newUser = {
				...state.auth.user,
				allUser: state.auth.user.allUser.map((x) =>
					x._id === action.payload._id ? action.payload : x
				),
			};
			return { ...state, user: newUser };
		case USER_LOADED:
			return {
				...state,
				isAuthenticated: true,
				isLoading: false,
				isFailed: false,
				user: action.payload,
				errorappMessage: null,
			};
		case SAVE_USER_PROFILE:
			console.log("SAVE_USER_PROFILE state=", state);
			let auth = state;
			auth.user.profile = action.payload;

			return { ...state, user: auth.user };

		case USER_LOADING:
			return {
				...state,
				isAuthenticated: false,
				isLoading: true,
				isFailed: false,
				errorappMessage: null,
			};

		case LOGIN_SUCCESS:
			return {
				...state,
				...action.payload,
				isAuthenticated: true,
				isLoading: false,
				isFailed: false,
				errorappMessage: null,
			};
		case AUTH_ERROR:
			localStorage.removeItem("token");
			localStorage.removeItem("selectedCompanyId");
			return {
				...state,
				token: null,
				user: { profile: {} },
				isAuthenticated: false,
				isLoading: false,
				isFailed: false,
				errorappMessage: action.payload,
			};
		case LOGOUT_USER:
		case LOGIN_FAIL:
		case LOGOUT_SUCCESS:
			localStorage.removeItem("token");
			localStorage.removeItem("selectedCompanyId");
			return {
				...state,
				token: null,
				user: { profile: {} },
				isAuthenticated: false,
				isLoading: false,
				isFailed: false,
				errorappMessage: null,
			};
		case APP_REGISTER_INIT:
			return {
				...state,
				app_is_registering: false,
				app_registation_completed: false,
				app__token_saved: false,
				app_user: null,
				app_deviceInfo: null,
				App_RegistrationStep: 0,
			};

		case APP_REGISTER_FAILED:
			return {
				...state,
				app_is_registering: false,
				App_RegistrationStep: 0,
				app_is_token_saving_failed: true,
			};
		case APP_REGISTER_COMPLETED:
			return {
				...state,
				app_is_registering: false,
				App_RegistrationStep: 2,
				app_registation_completed: true,
			};
		case APP_REGISTER_INIT:
			return {
				...state,
				app_is_registering: false,
				app_registation_completed: false,
				app__token_saved: false,
				app_user: null,
				app_deviceInfo: null,
				App_RegistrationStep: 0,
			};

		case APP_REGISTER_FAILED:
			return {
				...state,
				app_is_registering: false,
				App_RegistrationStep: 0,
				app_is_token_saving_failed: true,
			};
		case APP_REGISTER_COMPLETED:
			return {
				...state,
				app_is_registering: false,
				App_RegistrationStep: 2,
				app_registation_completed: true,
			};

		case APP_SAVE_USER_INFO:
			return {
				...state,
				app_is_registering: false,
				app_is_token_saving_failed: false,
				app__token_saved: false,
				app_user: action.payload,
				appMessage: null,
				App_RegistrationStep: 1,
			};
		case APP_SAVE_USER_INFO_FAIL:
			return {
				...state,
				app_is_registering: false,
				action: action.payload.action,
				appMessage: action.payload.message,
				app_is_token_saving_failed: true,
				app__token_saved: false,
				App_RegistrationStep: 0,
			};

		case APP_SAVE_USER_TOKEN_FAILED:
			return {
				...state,
				app_is_registering: false,
				app__token_saved: false,
				app_is_token_saving_failed: true,
				action: action.payload.action,
				appMessage: action.payload.message,
				App_RegistrationStep: 1,
			};
	}
	switch (action.type) {
		case APP_SAVE_DEVICE_INFO:
			return {
				...state,
				app_is_registering: false,
				app__token_saved: false,
				app_is_token_saving_failed: false,
				app_deviceInfo: action.payload,
				appMessage: null,
			};

		case APP_REGISTER_LOADING:
			return {
				...state,
				app_is_registering: true,
				app_is_token_saving_failed: false,
				appMessage: null,
			};

		default:
			return state;
	}
}